module.exports = __webpack_public_path__ + "static/media/21ECLAC52.7885c988.jpg";